import DOMPurify from "dompurify";

// Sanitize HTML from the WYSIWYG for safe insertion via dangerouslySetInnerHTML.
export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["p", "br", "b", "strong", "i", "em", "u", "s", "a", "h2", "h3", "ul", "ol", "li", "blockquote", "code", "pre"],
    ALLOWED_ATTR: ["href", "target", "rel", "class"],
  });
}
